export enum NotificationType {
    LIST = 'list_notifications',
    ADD = 'add_notification',
    READ = 'read',
    READ_ALL = 'read_all',
}